<template>
  <div>
    <navigationBar></navigationBar>
    <router-view></router-view>
    <bottomNavigationBar></bottomNavigationBar>
    
  </div>
</template>

<script setup>
import navigationBar from '@/components/NavigationBar/navigationBar.vue';
import bottomNavigationBar from '@/components/NavigationBar/bottomNavigationBar.vue';

</script>

<style>
html, body {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: sans-serif;
}

* {
  box-sizing: border-box;
}
</style>
